import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]
		.GET_WORKS_MATERIAL_PRODUCTION_RATE_NORMS]: {
		url: '/company/:companyId/works_material_production_rate_norms/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]
		.GET_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_production_rate_norms/:worksMaterialProductionRateNormId/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]
		.CREATE_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_production_rate_norms/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]
		.PATCH_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_production_rate_norms/:worksMaterialProductionRateNormId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]
		.PUT_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_production_rate_norms/:worksMaterialProductionRateNormId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]
		.DELETE_WORKS_MATERIAL_PRODUCTION_RATE_NORM]: {
		url: '/company/:companyId/works_material_production_rate_norms/:worksMaterialProductionRateNormId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}

